const s=s=>s instanceof Error?JSON.stringify({message:s.message,stack:s.stack,name:s.name}):JSON.stringify({message:s});export{s as getNormalizedErrorMessage};
